<template>
    <div>
        <form-wrapper :validator="$v.model" class="form-wrapper">
            <form-group label="Api Key" name="apiKey">
                <md-input v-model.trim="model.apiKey" />
            </form-group>
            <form-group label="Api Secret" name="apiSecret">
                <md-input v-model.trim="model.apiSecret" />
            </form-group>
        </form-wrapper>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'LalamoveKeys',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            model: {
                apiKey: '',
                apiSecret: ''
            }
        };
    },
    validations() {
        return {
            model: {
                apiKey: { required },
                apiSecret: { required }
            }
        };
    },
    methods: {
        update() {
            this.$v.model.$touch();
            if (this.$v.model.$invalid) 
                return;

            this.$emit('onUpdate', { lalamoveAccess: { ...this.model } });
        }
    },
    watch: {
        data(value) {
            Object.assign(this.model, value);
        }
    }
};
</script>
